<template>
    <form class="pt-10 flex justify-center h-full pb-10" @submit.prevent="login()">
        <alert ref="alert"></alert>

        <div class="w-4/5 md:w-1/3">
            <div class="flex my-3 justify-center p-12 px-20">
                <logo></logo>
            </div>

            <div class="my-3">
                <input type="email" :placeholder="$t('email')"
                       name="email"
                       v-model="email"
                       class="input w-full">
            </div>

            <div class="my-3">
                <input type="password" :placeholder="$t('password')"
                       name="password"
                       v-model="password"
                       class="input w-full">
            </div>

            <div class="my-3 md:flex block">
                <button
                        :disabled="loading"
                        type="submit"
                        class="btn btn-orange w-full md:w-1/2">
                    {{ $t("sign_in") }}
                </button>

                <button
                        @click="register()"
                        :disabled="loading"
                        type="button"
                        class="btn btn-blue my-2 md:my-0 md:w-1/2 md:ml-3">
                    {{ $t("sign_up") }}
                </button>
            </div>

            <div class="block text-center">
                <button @click="recover()" class="btn"
                        type="button"
                        :disabled="loading">
                    {{ $t("password_forgot")}}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {Auth} from "@/services/Api";

    export default {
        name: 'Login',

        data() {
            return {
                email: null,
                password: null,
                loading: false
            }
        },

        mounted() {
            let user = Auth.currentUser();

            if(user && user.email) {
                this.email = user.email;
            }
        },

        methods: {
            login() {
                this.loading = true;

                Auth.login(this.email, this.password)
                    .then(() => {
                        this.$emit('loggedIn');

                        if(this.$route.params.nextUrl != null){
                            this.$router.push(this.$route.params.nextUrl)
                        } else {
                            this.$router.push('/install')
                        }
                    })
                    .catch(e => {
                        this.$refs.alert.showResponseErrors(e)
                    })
                    .finally(
                        () => this.loading = false
                    )
            },

            register() {
                this.$router.push('/register');
            },

            recover() {
                this.$router.push('/password-recover');
            }
        }
    }
</script>
